import { Modal } from "react-bootstrap";

const StorePickupModal: React.FC<{ showStorePickupModal: boolean; setStorePickupModal: Function }> = ({
  showStorePickupModal,
  setStorePickupModal,
}) => {
  return (
    <div className='store-pickup-modal-container'>
      <Modal show={showStorePickupModal} onHide={() => setStorePickupModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>In-store pickup is only available at these retail locations:</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className='table table-striped'>
            <thead className='thead-light'>
              <tr>
                <th>Location</th>
                <th>Hours</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <a
                    href='https://www.google.com/maps/place/Comporium/@35.0480551,-80.9936254,15z/data=!4m5!3m4!1s0x0:0x730336ec6cef409d!8m2!3d35.0480551!4d-80.9936254'
                    target='_blank'
                    rel='noreferrer'>
                    Fort Mill
                  </a>
                </td>
                <td>Mon-Fri 9am-6pm</td>
              </tr>
              <tr>
                <td>
                  <a
                    href='https://www.google.com/maps/place/Comporium/@34.9593013,-81.0100669,17z/data=!3m1!4b1!4m5!3m4!1s0x885688b7f2da2db7:0xe24dd3c04e7bfece!8m2!3d34.9593013!4d-81.0078782'
                    target='_blank'
                    rel='noreferrer'>
                    Rock Hill
                  </a>
                </td>
                <td>Mon-Fri 9am-6pm</td>
              </tr>
              <tr>
                <td>
                  <a
                    href='https://www.google.com/maps/place/Comporium/@34.7342859,-80.7886309,15z/data=!4m5!3m4!1s0x0:0x3956abf9f1189c04!8m2!3d34.7342859!4d-80.7886309'
                    target='_blank'
                    rel='noreferrer'>
                    Lancaster
                  </a>
                </td>
                <td>Mon-Fri 9am-6pm</td>
              </tr>
              <tr>
                <td>
                  <a
                    href='https://www.google.com/maps/place/Comporium/@35.2319772,-82.7319961,19z/data=!4m5!3m4!1s0x8859bb338613ab7b:0x1ecf136c864bd61!8m2!3d35.2320042!4d-82.7313673'
                    target='_blank'
                    rel='noreferrer'>
                    Brevard
                  </a>
                </td>
                <td>Mon-Fri 8am-5pm</td>
              </tr>
              <tr>
                <td>
                  <a
                    href='https://www.google.com/maps/place/Comporium/@35.2319772,-82.7319961,19z/data=!4m5!3m4!1s0x8859bb338613ab7b:0x1ecf136c864bd61!8m2!3d35.2320042!4d-82.7313673'
                    target='_blank'
                    rel='noreferrer'>
                    Chesnee
                  </a>
                </td>
                <td>Mon-Fri Mon-Fri 8:00am - 11am and 12pm - 5pm</td>
              </tr>
              <tr>
                <td>
                  <a
                    href='https://www.google.com/maps/place/Comporium/@34.9405077,-80.8394861,17z/data=!3m1!4b1!4m5!3m4!1s0x885681967914eeb3:0xe3c27494c4b68b93!8m2!3d34.9405077!4d-80.8372974'
                    target='_blank'
                    rel='noreferrer'>
                    Indian Land
                  </a>
                </td>
                <td>Mon-Fri 9am-6pm</td>
              </tr>
              <tr>
                <td>
                  <a
                    href='https://www.google.com/maps/place/Comporium/@33.8779145,-81.3803391,15z/data=!4m13!1m7!3m6!1s0x88f88d1e8949c05f:0x71ee1ba6e35597d2!2s1660+Juniper+Springs+Rd,+Gilbert,+SC+29054!3b1!8m2!3d33.878258!4d-81.381098!3m4!1s0x88f88d1e92442441:0x67b3da9f1af23beb!8m2!3d33.878291!4d-81.380988'
                    target='_blank'
                    rel='noreferrer'>
                    Gilbert
                  </a>
                </td>
                <td>Mon-Fri 8am-5pm</td>
              </tr>
            </tbody>
          </table>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default StorePickupModal;
